module.exports = __webpack_public_path__ + "static/media/IngredientImagePlaceholder2.904a0723.png";